import { render, staticRenderFns } from "./PolyIntegerReferenceIndex.vue?vue&type=template&id=30096e10&"
import script from "./PolyIntegerReferenceIndex.vue?vue&type=script&lang=js&"
export * from "./PolyIntegerReferenceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports